export default "__VITE_ASSET__CwPiZMAH__"